import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
// import moment from 'moment'
import 'moment/locale/es';
import {
    Link
} from "react-router-dom";
// import useScript from '../../components/useScript';

const Grupos = (props) => {

    const grupos = useSelector((state) => state.bases._get_groups);
    const [data, setData] = useState(grupos);
    const {token} = props;


    useEffect(() => {
        setData(grupos);
    }, [grupos])

    return (
        <>
            <div class="section-header">
                <h1>Lista de roles y permisos</h1>
            </div>

            <div class="section-body">
            </div>
            <div class="row">
                <div class="col-12 col-md-12 col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>Listado</h4>
                            <br/>
                            {token.permissions.indexOf('auth.add_group') !== -1 && (
                                <Link to="/roles-permisos/crear-rol" class="btn btn-success">Crear rol</Link>
                            )}
                        </div>
                        <div class="card-body">

                            <div class="table-responsive">

                                <table class="table table-bordered table-md" id="table">
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombres</th>
                                        {token.permissions.indexOf('auth.change_group') !== -1 &&
                                        <th>Acciones</th>
                                        }
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        data.map((item, index) => (
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td>{item.nombre}</td>
                                                {token.permissions.indexOf('auth.change_group') !== -1 &&
                                                <td><Link to={`/roles-permisos/editar-rol/${item.id}`} class="btn btn-secondary">Editar</Link></td>
                                                }
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Grupos;
